<template>
  <div>

  </div>
</template>

<script>
export default {
  name: 'MemberSendSMS'
}
</script>

<style scoped>

</style>
